import React from 'react';
import ProcedureTab from './ProcedureTab';
import { PROCEDURE_CATEGORIES } from '../../types/ProcedureTypes';

interface ChartererTabProps {
    procedures: any[];
    loading: boolean;
    error: string | null;
    selectedProcedure: any;
    setSelectedProcedure: (procedure: any) => void;
    onRefresh?: () => void;
}

const ChartererTab: React.FC<ChartererTabProps> = (props) => {
    const config = {
        title: 'Charterer Procedures',
        description: 'Charterer information and requirements',
        icon: 'fa-building',
        category: PROCEDURE_CATEGORIES.CHARTERER,
        columns: [
            {
                key: 'title',
                header: 'Title',
            },
        ],
    };

    return <ProcedureTab config={config} {...props} />;
};

export default ChartererTab;
